import axios from "axios";

class PageCategoryService {
  getCategories() {
    return axios
      .get("/sitecore/shell/client/Applications/altola/insights/data/categories.json")
      .then(res => {
        //const all = { "Name": "All", "Color": "grey", "Pattern": "All" };
        const categories = res.data;
        //categories.unshift(all);
        return categories;
      })
      .catch(err => {
        console.error(err);
        return [];
      });
  }
}

export default new PageCategoryService();



// WEBPACK FOOTER //
// ./src/data/PageCategoryService.dev.js